import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={19}
    viewBox={'0 0 20 19'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      fill={props.fill || '#fff'}
      d="M11.81 0v7.206l6.92-2.456L20 8.337l-6.92 2.294 4.285 6.075L14.222 19l-4.159-6.301L5.873 19l-3.238-2.294 4.35-6.075L0 8.337 1.27 4.75l6.857 2.52V0h3.682Z"
    />
  </Svg>
);
export default SvgComponent;
